import React from 'react'
import { Route } from 'react-router-dom'
// import { login } from '../middleware'
import { Cookies } from 'react-cookie'

const cookies = new Cookies()

const PrvateRoute = ({ component: C, props: cProps, ...rest }) => (
  <Route
    {...rest}
    render={props => ((cookies.get('user') === undefined || cookies.get('user') === null || cookies.get('user') === '') ? ((window.location = process.env.REACT_APP_AUTH_URL)) : (<C {...props} {...cProps} />))} />
)

export default PrvateRoute